import React, { useState } from 'react'
import { Box, TextInput } from '../../../../components/DesignSystem'
import { View } from '../../../../components/Themed'
import { formStyle, mediumTextSize } from '../../../../constants/GlobalStyle'
import Colors from '../../../../constants/Colors'
import { useAppSelector } from '../../../../state/hooks'

import { auth } from '../../../../firebase/config'
import { userCanRedeem } from '../../Helpers/checkCouponCode'
import { Text, Stack, Button, Inline, Spread } from '../../../../components/DesignSystem'
const KIOSK_PROMO_ERROR = 'Promo code not redeemable on kiosk'
const WEB_GUEST_PROMO_ERROR = 'Promo code only available to registered users'

export function AddPromo({ promoFuncData, staffMeal = true }) {
	const { deviceHasInternet } = useAppSelector(state => state.user)
	const { userRedeemedCodes, userAvailableCodes, isGuestCheckout } = useAppSelector(
		state => state.checkout
	)
	const { couponCodeDisplay, couponCode, validCouponCodes } = useAppSelector(
		state => state.persisted
	)
	const [promoCode, setPromoCode] = useState('')
	const [couponCodeError, setCouponCodeError] = useState('')

	const generatePromoCodeError = (promoValue: string) => {
		const promo = validCouponCodes.find(
			code => code.couponCode.toLowerCase() === promoValue.toLowerCase()
		)

		if (!promo) return setCouponCodeError('Invalid promo code.')
	}

	const handleSetPromoCode = (value: string) => {
		setPromoCode(value)
		generatePromoCodeError(value)
	}

	const handlePromoSubmit = (promoValue: string) => {
		setCouponCodeError('')

		const promo = validCouponCodes.find(
			code => code.couponCode.toLowerCase() === promoValue.toLowerCase()
		)

		// Block if promotion code is unlimited use and is on kiosk or is a guest checkout.
		if (promo?.redemptionQty !== -1) {
			if (global.kiosk) return setCouponCodeError(KIOSK_PROMO_ERROR)
			if (isGuestCheckout) return setCouponCodeError(WEB_GUEST_PROMO_ERROR)
		}

		if (userCanRedeem(promo, userRedeemedCodes)) {
			promoFuncData.setPromo(promoValue)
		} else {
			return setCouponCodeError('Promo code has been redeemed too many times.')
		}
	}

	const availablePromos =
		validCouponCodes?.filter(promo => {
			if (promo.codeOnly || promo.type === 'staffMeal') return false

			if (!promo.customerSpecific) return true

			if (auth.currentUser && userCanRedeem(promo, userRedeemedCodes)) {
				return userAvailableCodes.some(code => promo.id === code)
			}

			return false
		}) || []

	return (
		<Stack gap="lg">
			<Text weight="semibold" tone="tertiary" level="large">
				{`DO YOU HAVE A PROMO CODE?`}
			</Text>

			<Stack gap="lg">
				<Stack gap="xs">
					<Inline gap="sm">
						<Inline style={{ flex: 1 }}>
							<TextInput
								returnKeyType={'done'}
								placeholder={'Promo code'}
								value={promoCode}
								onChangeText={handleSetPromoCode}
								onSubmitEditing={() => handlePromoSubmit(promoCode)}
							/>
						</Inline>
						<Button
							onPress={() => handlePromoSubmit(promoCode)}
							disabled={!deviceHasInternet || promoCode.length <= 0}
							backgroundColor={
								!deviceHasInternet || promoCode.length <= 0 ? Colors.greyscale[6] : global.orgColor
							}
							size="medium"
							variant="primary"
							weight="medium"
						>
							Apply
						</Button>
					</Inline>

					{couponCodeError ? (
						<View>
							<Text tone="critical" level="small">
								{couponCodeError}
							</Text>
						</View>
					) : null}

					{!couponCodeError && couponCodeDisplay ? (
						<View>
							<Text
								level="small"
								style={{
									color: couponCodeDisplay.endsWith('was applied to your order.') ? 'green' : 'red',
								}}
							>
								{couponCodeDisplay}
							</Text>
						</View>
					) : null}
				</Stack>

				{availablePromos.length > 0 && (
					<Stack gap="lg">
						<Text weight="medium" tone="tertiary" level="large">
							AVAILABLE PROMOS:
						</Text>
						<Stack>
							{availablePromos.map(promo => (
								<Spread key={promo.couponCode} alignY="center">
									<Inline gap="xs">
										<Text weight="semibold">{promo.name}:</Text>
										<Text>
											{promo.rate.type === 'percent'
												? `${promo.rate.amount}%`
												: `$${promo.rate.amount}`}{' '}
											OFF
										</Text>
									</Inline>
									<Button
										size="small"
										onPress={() => {
											handleSetPromoCode(promo.couponCode)
											handlePromoSubmit(promo.couponCode)
										}}
										style={{ paddingHorizontal: 12, paddingVertical: 4 }}
									>
										Add to order
									</Button>
								</Spread>
							))}
						</Stack>
					</Stack>
				)}
			</Stack>
		</Stack>
	)
}
